module.exports = __webpack_public_path__ + "static/media/活动任务要求.0b596a91.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/activity_170/img/活动任务要求.png
// module id = 1512
// module chunks = 0